import api from '../api/directors'
import apiBrokers from '../api/brokers'
import apiNews from '../api/news'
import { changeOrder } from './meta'
import { fetchSection } from './api'
import * as urls from '../constants/api'
import apiImi from '../api/imi'

export const actionTypes = {
	RECEIVE_DIRECTORS: 'hotels/RECEIVE_DIRECTORS',
  RECEIVE_BROKERS: 'hotels/RECEIVE_BROKERS',
  RECEIVE_NEWS: 'hotels/RECEIVE_NEWS',
  RECEIVE_IMIS: 'retails/RECEIVE_IMIS',
  SAVE_ORDER: 'hotels/SAVE_ORDER'
}

export const loadDirectorsBySector = (id) => {
  return(dispatch, getStore) => {
    api.fetchDirectorsBySector(id)
      .then((data) => dispatch(receiveDirectors(data)))
  }
}

function receiveDirectors(APIdata) {
  return {
    type: actionTypes.RECEIVE_DIRECTORS,
    data: APIdata.data
  }
}

export const loadBrokers = (id) => {
  return(dispatch, getStore) => {
    apiBrokers.fetchBrokers(id)
      .then((data) => dispatch(receiveBrokers(data)))
  }
}

function receiveBrokers(APIdata) {
  return {
    type: actionTypes.RECEIVE_BROKERS,
    data: APIdata.data
  }
}

export const loadNewsBySector = (id) => {
  return(dispatch, getStore) => {
    apiNews.fetchNewsBySector(id)
      .then((data) => dispatch(receiveNews(data)))
  }
}

function receiveNews(APIdata) {
  return {
    type: actionTypes.RECEIVE_NEWS,
    data: APIdata
  }
}

export const setOrder = (value) => {
  return (dispatch) => {
    dispatch(saveOrder(value))
    dispatch(changeOrder(value.id))
    dispatch(fetchSection(urls.HOTELS))
  }
}

function saveOrder(value) {
  return {
    type: actionTypes.SAVE_ORDER,
    data: value
  }
}

export const loadImisBySector = (id) => {
  return(dispatch, getStore) => {
    apiImi.fetchImisBySector(id)
      .then((data) => dispatch(receiveImis(data)))
  }
}

function receiveImis(APIdata) {
  return {
    type: actionTypes.RECEIVE_IMIS,
    data: APIdata.data
  }
}



// WEBPACK FOOTER //
// ./src/actions/hotels.js